import { createFileRoute, Navigate } from '@tanstack/react-router';
import { SettingsView } from '../../components/SettingsView';

const isSubscriptionsEnabled = import.meta.env.VITE_FEATURE_SUBSCRIPTIONS_ENABLED === 'true';

export const Route = createFileRoute('/settings/subscription')({
  component: SubscriptionPage,
});

function SubscriptionPage() {
  if (!isSubscriptionsEnabled) {
    return <Navigate to="/settings" />;
  }
  return <SettingsView initialTab="subscription" />;
}
